import { createTheme } from "@mantine/core"

export const theme = createTheme({
  autoContrast: true,
  colors: {
    theaRed: [
      "#ffe9f2",
      "#fed2e0",
      "#f7a4bd",
      "#f17299",
      "#ec497a",
      "#ea2f66",
      "#ea205c",
      "#d0134d",
      "#bb0943",
      "#a4003a",
    ],
  },
  components: {
    Input: {
      styles: () => ({
        input: {
          fontSize: 16,
        },
      }),
    },
    DateTimePicker: {
      defaultProps: {
        valueFormat: "L LT",
      },
    },
    DateInput: {
      defaultProps: {
        valueFormat: "L",
      },
    },
    DatePickerInput: {
      defaultProps: {
        valueFormat: "L",
      },
    },
    Modal: {
      defaultProps: {
        closeOnClickOutside: false,
      },
    },
    Stack: {
      defaultProps: {
        gap: "xs",
      },
    },
    Group: {
      defaultProps: {
        gap: "xs",
      },
    },
  },
  breakpoints: {
    xxl: "106em",
    xxxl: "125em",
    xxxxl: "164em",
  },
  defaultRadius: "sm",
})
